import React, { useEffect } from "react";
import { toggleCompanyMMT } from "../../Services/MMT.service";
import { showAlert } from "../../Services/Shared.service";

const ToggleSwitch = ({isChecked,companyId,type,setShowApiLoader,index,fetchTableData}) => {

 const togglePickupType=()=>{
    let obj={
      companyId
    }
    const body={
      type
    }
    setShowApiLoader(true)
    toggleCompanyMMT(obj,body).then(result=>{
      showAlert("success","Updated Successfully");
      fetchTableData();
    }).catch((err)=>{
      setShowApiLoader(false)
      showAlert('error','Something went wrong');
    })
  }

  return (
    <div className="custom-toggle-switch">
      <input
        type="checkbox"
        checked={isChecked?true:false}
        onChange={(e) => {
          togglePickupType();
        }}
        id={"switch"+index+type}
      />
      <label htmlFor={"switch"+index+type}></label>
    </div>
  );
};

export default ToggleSwitch;
